import { z } from 'zod';

/**
 * iCal RRULE string.  Format documented at
 * https://datatracker.ietf.org/doc/html/rfc5545#section-3.3.10
 *
 * Common forms:
 *   FREQ=DAILY
 *   FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR
 *   FREQ=MONTHLY;BYMONTHDAY=1
 *   FREQ=MONTHLY;INTERVAL=3
 *
 * Server validates by attempting to parse via `rrule` library — bad
 * strings return 400.
 */
const RRule = z.string().min(3).max(500);

export const RecurringTaskSpecSchema = z.object({
  id: z.string().uuid(),
  templateTaskId: z.string().uuid(),
  rrule: z.string(),
  nextRunAt: z.string(),
  endAt: z.string().nullable(),
  lastSpawnedAt: z.string().nullable(),
  createdBy: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type RecurringTaskSpecProjection = z.infer<typeof RecurringTaskSpecSchema>;

export const CreateRecurringSpecSchema = z
  .object({
    rrule: RRule,
    endAt: z.string().datetime().nullable().optional(),
  })
  .strict();
export type CreateRecurringSpecInput = z.infer<typeof CreateRecurringSpecSchema>;

export const UpdateRecurringSpecSchema = z
  .object({
    rrule: RRule.optional(),
    endAt: z.string().datetime().nullable().optional(),
  })
  .strict();
export type UpdateRecurringSpecInput = z.infer<typeof UpdateRecurringSpecSchema>;
